import { call, put, takeEvery } from 'redux-saga/effects';
import { getLeadsAffiliate } from '../../requests/get_leads_affiliate_request';
import {
    getLeadsAffiliateSuccess,
    getLeadsAffiliateFailure,
} from '../actions/get_leads_affiliate.actions';
import { GET_LEADS_AFFILIATE } from '../constants/get_leads_affiliate.constants';

function* getLeadsAffiliateRequest() {
    const leadsAffiliate = yield call(getLeadsAffiliate); const
        { result, options } = leadsAffiliate;
    result
        ? yield put(getLeadsAffiliateSuccess(options))
        : yield put(getLeadsAffiliateFailure('Something gone wrong!'));
}

export default function* getLeadsAffiliateSaga() {
    yield takeEvery(GET_LEADS_AFFILIATE, getLeadsAffiliateRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/sagas/get_lead_affiliate.saga.js